import '../styles/Home.css';
import "../../node_modules/uikit/dist/css/uikit.css";
import * as s from "../styles/globalStyles";
import Web3 from 'web3';
import Web3Modal from "web3modal";
import Web3EthContract from "web3-eth-contract";
import WalletConnectProvider from "@walletconnect/web3-provider";
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';



let web3Modal;
let web3;
let usersWallet;
let stakedWallet;

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: '9aa3d95b3bc440fa88ea12eaa4456161'
    },
    network: "mainnet"
  }
};

let cost = BigInt(15000000000000000000);

//const goodle_address = "0x90F15FD4C468E87BA1e6bDB7595B984D965C44fB";
const goodle_address = "0x90F15FD4C468E87BA1e6bDB7595B984D965C44fB";
const staking_address = "0x4DeFfF37f5A2165253aD7e0d03ab7a919cE01FeF";
//const goodle_address = "0xEA2AA9511fccf7F90220AaD32904Cc53aE4152C4";
//let ipfs_img_link = "https://goodledoggang.mypinata.cloud/ipfs/Qme8TzJCfkQEo3ETa324kB4efQ5Nan23UZTkhxm1355eqa/79.png";
let userJson;
let userResults;

const abi = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_initBaseURI",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "_initNotRevealedUri",
                "type": "string"
            },
            {
                "internalType": "address[]",
                "name": "_payees",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "_shares",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "approved",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "contract IERC20",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "ERC20PaymentReleased",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "shares",
                "type": "uint256"
            }
        ],
        "name": "PayeeAdded",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "PaymentReceived",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "PaymentReleased",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "addressMintAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "baseExtension",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_goodleId",
                "type": "uint256"
            },
            {
                "internalType": "string",
                "name": "_newName",
                "type": "string"
            }
        ],
        "name": "changeName",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "cost",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "getApproved",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "goodleIdToUri",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "goodleUriRemapped",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "_users",
                "type": "address[]"
            },
            {
                "internalType": "uint256[]",
                "name": "_amount",
                "type": "uint256[]"
            }
        ],
        "name": "goodlistUsers",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_user",
                "type": "address"
            }
        ],
        "name": "goodlistedAllowance",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_user",
                "type": "address"
            }
        ],
        "name": "isGoodlisted",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxMintAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_mintAmount",
                "type": "uint256"
            }
        ],
        "name": "mint",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "nameCost",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "nameTaxed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "nameable",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "notRevealedUri",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ownerOf",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "pCost",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "_state",
                "type": "bool"
            }
        ],
        "name": "pause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "paused",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "payee",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "preSale",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "preSaleAddresses",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "preSaleAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address payable",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "release",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC20",
                "name": "token",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "release",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC20",
                "name": "token",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "released",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "released",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_goodleId",
                "type": "uint256"
            }
        ],
        "name": "resetName",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "reveal",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "revealed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "_data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_newBaseExtension",
                "type": "string"
            }
        ],
        "name": "setBaseExtension",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_newBaseURI",
                "type": "string"
            }
        ],
        "name": "setBaseURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_newCost",
                "type": "uint256"
            }
        ],
        "name": "setCost",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_newNameCost",
                "type": "uint256"
            }
        ],
        "name": "setNameCost",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "_state",
                "type": "bool"
            }
        ],
        "name": "setNameTaxed",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "_state",
                "type": "bool"
            }
        ],
        "name": "setNameable",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_notRevealedURI",
                "type": "string"
            }
        ],
        "name": "setNotRevealedURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_newPCost",
                "type": "uint256"
            }
        ],
        "name": "setPCost",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "_state",
                "type": "bool"
            }
        ],
        "name": "setPreSale",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_newmaxMintAmount",
                "type": "uint256"
            }
        ],
        "name": "setmaxMintAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "shares",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "symbol",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "tokenByIndex",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "tokenOfOwnerByIndex",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "tokenURI",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC20",
                "name": "token",
                "type": "address"
            }
        ],
        "name": "totalReleased",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalReleased",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalShares",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_owner",
                "type": "address"
            }
        ],
        "name": "walletOfOwner",
        "outputs": [
            {
                "internalType": "uint256[]",
                "name": "",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
]

const stake_abi = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_id",
                "type": "uint256"
            }
        ],
        "name": "calculateOddReward",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_id",
                "type": "uint256"
            },
            {
                "internalType": "bool",
                "name": "unstaked",
                "type": "bool"
            }
        ],
        "name": "claimOddRewards",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "emergencyUnstake",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokenIds",
                "type": "uint256[]"
            }
        ],
        "name": "emergencyUnstakeByUser",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "idToToken",
        "outputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "timestamp",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC721",
                "name": "_new_address",
                "type": "address"
            }
        ],
        "name": "set_odd_contract",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC20",
                "name": "_pickles",
                "type": "address"
            }
        ],
        "name": "set_pickles_contract",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_id",
                "type": "uint256"
            }
        ],
        "name": "stake",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "stakedBalanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "stakingInfoOdds",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "timestamp",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "rewards",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct OddStaking.StakingInfoOdds[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "stakingsByOwner",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_id",
                "type": "uint256"
            }
        ],
        "name": "timeStaked",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
]

function Naming() {
  
  let navigate = useNavigate();
  const [isConnected, setIsConnected] = useState(false);
  const [signer, setSigner] = useState();
  const [ipfsImgLink, setIpfsImgLink] = useState("../images/monstergif.gif");
  const [currentNFT, setCurrentNFT] = useState(0);
  const [pinataJson, setPinataJson] = useState("");
  const [walletUploaded, setWalletUploaded] = useState(false);
  const [jsonUploaded, setJsonUploaded] = useState(false);
  const [nameLoaded, setNameLoaded] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [staking, setStaking] = useState(true);
  const [unstaking, setUnstaking] = useState(false);

  async function connect() {
    web3Modal = new Web3Modal({
      cacheProvider: false,
      providerOptions, ///required
    })
    try {
      const web3ModalProvider = await web3Modal.connect();
      web3 = new Web3(web3ModalProvider);
      Web3EthContract.setProvider(web3ModalProvider);
      let accounts = await web3.eth.getAccounts();
        stakedWallet = [];
      setSigner(accounts[0]);
      setIsConnected(true);
      console.log("Connected");

      let odd_auth = new Web3EthContract(abi, goodle_address);
        let staking_info = new Web3EthContract(stake_abi, staking_address);


      
      let msg = await odd_auth.methods
          .isApprovedForAll(accounts[0], staking_address)
          .call()
          setIsAuthorized(msg);
        console.log(msg);


        let stake_msg = await staking_info.methods
          .stakingInfoOdds(accounts[0])
          .call()
          for (let i = 0; i < stake_msg.length; i++) {
            console.log(stake_msg[i]['tokenId']);
            stakedWallet.push(stake_msg[i]['tokenId']);

          }
          console.log(stakedWallet);
          
    } catch (e) {
      console.log(e);
    }   

  }

  async function fetchUserData() {

    
    try {
      let name_goodle = new Web3EthContract(abi, goodle_address);
      
      
      let msg = await name_goodle.methods
          .walletOfOwner(signer)
          .call()

        
      usersWallet = msg;
      console.log(usersWallet);
      setWalletUploaded(true);
    } catch (e) {
      console.log(e);
    }
  }

  function fetchIPFSData() {
    if (usersWallet.length == 0) {
        alert("Need Odds To Stake!");
        return;   
             
    }
    setIpfsImgLink("../images/black.png");
    setIpfsImgLink("https://goodledoggang.mypinata.cloud/ipfs/QmczgteJpwXooPWNd4wyUruT948V6wvVQUc1bb5RjvdLDr/" + usersWallet[0] + ".png");
    //fetchIpfsJson(usersWallet[0]);
    console.log(ipfsImgLink);
    console.log(usersWallet.length);
    setJsonUploaded(true);
    setStaking(false);

  }

  async function fetchIpfsJson(fetchingData) {

    let response = await fetch("https://goodledoggang.mypinata.cloud/ipfs/QmVLtaiQaiUHuHXUvDjTYCLmUbhgA6iKN26bDnmry3LXMb/" + fetchingData + ".json");
    userJson = await response.json();
    console.log(userJson);
    //getPinata(userJson);
    setJsonUploaded(true);
   

  }
  const getPinata = (newName) => {

    const pinataSDK = require('@pinata/sdk');
    const pinata = pinataSDK('44d097a6418e9de81c42','2c21e820666bb7887d8b69dbf01c62a4d5b35053bf9e311e9771a1b0b7922fb1');
    let userJ = userJson;
    let body = {
        name: newName,
        description: userJ.description,
        image: userJ.image,
        dna: userJ.dna,
        edition: userJ.edition,
        date: userJ.date,
        attributes: userJ.attributes,
        developer: userJ.developer
    };
    

    pinata.testAuthentication().then((result) => {
      console.log(result);
    }).catch((err) => {
      console.log(err);
    });

    pinata.pinJSONToIPFS(body).then((result) => {
      //handle results here
      console.log(result.IpfsHash);
      setPinataJson("ipfs://" + result.IpfsHash);
      setNameLoaded(true);
    }).catch((err) => {
      //handle error here
      console.log(err);
    });
    

  };

  function plusNFT() {
    if (currentNFT < usersWallet.length - 1) {
        let newLength = currentNFT + 1;
        console.log(newLength);
        
        console.log(currentNFT);
        setIpfsImgLink("https://goodledoggang.mypinata.cloud/ipfs/QmczgteJpwXooPWNd4wyUruT948V6wvVQUc1bb5RjvdLDr/" + usersWallet[newLength] + ".png");
        //fetchIpfsJson(usersWallet[newLength]);
        setCurrentNFT(newLength);
    }
  }

  function minusNFT() {
    if (currentNFT > 0) {
        let newLength = currentNFT - 1;
        console.log(newLength);
        
        console.log(currentNFT);
        setIpfsImgLink("https://goodledoggang.mypinata.cloud/ipfs/QmczgteJpwXooPWNd4wyUruT948V6wvVQUc1bb5RjvdLDr/" + usersWallet[newLength] + ".png");
        //fetchIpfsJson(usersWallet[newLength]);
        setCurrentNFT(newLength);
    }
  }
  
  function nameThatGoodle(msg) {
    
    let swears = ["fuck", "cunt", "bitch", "dick", "twat", "fag", "faggot", "pussy"];

    for (let i = 0; i < swears.length; i++) {
        if (msg.toLowerCase().includes(swears[i])) {
            alert("No Swears Allowed");
            return;
            
        }
    }
    
    getPinata(msg);
    


  }

  async function namingGoodle(mintAmount) {    
    
    
    console.log(pinataJson);
    try {
      let mint_goodle = new Web3EthContract(abi, goodle_address);
      
      
      
      
      let msg = await mint_goodle.methods
          .changeName(usersWallet[currentNFT], pinataJson)
          .send({from: signer, gasLimit: "2000000", gasPrice: "50000000000"});
          
      
      console.log(msg);
    } catch (e) {
      console.log(e);
    }

  
}

async function stake_nft() {

    

    try {
        let stake_nft = new Web3EthContract(stake_abi, staking_address);
        
        
        
        
        let msg = await stake_nft.methods
            .stake(usersWallet[currentNFT])
            .send({from: signer, gasLimit: "2000000", gasPrice: "50000000000"}).then(() => {
                refreshData();
              });
            
        
        console.log(msg);
        
      } catch (e) {
        console.log(e);
      }
}

async function authorize_users() {    
    
    
    
    try {
      let mint_goodle = new Web3EthContract(abi, goodle_address);
      
      
      
      
      let msg = await mint_goodle.methods
          .setApprovalForAll(staking_address, "true")
          .send({from: signer, gasLimit: "200000", gasPrice: "50000000000"});
          
      
      console.log(msg);
      setIsAuthorized(msg);
    } catch (e) {
      console.log(e);
    }

  
}

async function refreshData() {    
    
    
    
    try {
        let name_goodle = new Web3EthContract(abi, goodle_address);
        
        
        let msg = await name_goodle.methods
            .walletOfOwner(signer)
            .call()
  
          
        usersWallet = msg;
        console.log(usersWallet);
        setCurrentNFT(0);
        fetchIPFSData();
      } catch (e) {
        console.log(e);
      }

  
}

  return (

    <s.Screen>
      <s.Header>
          <button id="homeButton" className='uk-button uk-button-link'
            onClick={() => {
                navigate("/");
            }}>
                
          </button>
        { isConnected ?
          <button  id="connectedButton" className='uk-button uk-button-secondary uk-float-right' >Connected</button>
        :
          <button  id="connectButton" className='uk-button uk-button-secondary uk-float-right' 
            onClick={() => {
                connect();
            }}>
                Connect
          </button>

        }
        
      </s.Header> 
      <s.MidSection>
      <img id="smallGoodleNameImg" alt={"logo"} src={ipfsImgLink} className='uk-hidden@l'/>  
            <s.ExchangePanel>
            
                <s.InnerGoodlePanel className='uk-visible@l'>
                    
                    <img id="goodleNameImg" alt={"logo"} src={ipfsImgLink} />  
                </s.InnerGoodlePanel>
                
                <s.InnerPanel className='uk-animation-scale-up'>
                    <s.ExchangePanelHeader>
                        <p className="uk-card-title">Stake Your Odd Squadz</p>
                    </s.ExchangePanelHeader>
                    {isConnected ?
                    <s.ExchangePanelBody>

                        <s.InnerPanelPrice>  
                        {walletUploaded ? 
                        
                        <>
                        {staking ?
                        <button   
                        onClick={() => {
                            fetchIPFSData();
                          }}
                        className="uk-button uk-button-primary"  
                        >
                            Display
                        </button>
                        :
                        <button   
                        onClick={() => {
                            navigate("/unstake");
                        }}
                        className="uk-button uk-button-primary"  
                        >
                            UnStake
                        </button>
                        }
                        </>
                        :
                        <button  
                        onClick={() => {
                            fetchUserData();
                        }}
                        className="uk-button uk-button-primary"
                        >
                            Import
                        </button>
                        
                        }
                            <p className="uk-card-title">Earn Pickles!</p>                       
                                                            
                        </s.InnerPanelPrice>
                        <s.InnerPanelTextWrapper>
                            Welcome Squad
                            <br />
                            Stake Your Odd Squads Here
                        </s.InnerPanelTextWrapper>
                        {jsonUploaded ?
                        <s.InnerPanelMathWrapper>
                            <s.StyledRoundButton className="uk-button-primary uk-margin-small-right" onClick={() =>  minusNFT()}>-</s.StyledRoundButton>
                            {currentNFT+1}
                            <s.StyledRoundButton className="uk-button-primary uk-margin-small-left" onClick={() =>  plusNFT()}>+</s.StyledRoundButton>
                        </s.InnerPanelMathWrapper>
                        :
                        null
                        }
                    </s.ExchangePanelBody>
                    :
                    <s.ExchangePanelBody>
                        <s.InnerPanelPrice>
                            <p className="uk-card-title">Earn Pickles!</p>                       
                                                            
                        </s.InnerPanelPrice>
                        
                        <s.InnerPanelTextWrapper>
                            
                            Please Connect Wallet To Begin!
                            <br />
                            <br />
                            <button   
                            onClick={() => {
                                navigate("/unstake");
                            }}
                            className="uk-button uk-button-primary"  
                            >
                                UnStake
                            </button>
                        </s.InnerPanelTextWrapper>
                    </s.ExchangePanelBody>
                    }
                    {jsonUploaded ?
                    <s.ExchangePanelFooter
                        style={{textAlign: "center"}}
                    >
                       
                        
                        
                        <br />
                        {isAuthorized ? 
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                stake_nft();
                                
                            }}
                            
                            className="uk-button uk-button-primary uk-margin-top"
                        >Stake</button>
                        :
                        
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                authorize_users();
                            }}
                            
                            className="uk-button uk-button-primary uk-margin-top"
                        >Authorize</button>
                        }
                    </s.ExchangePanelFooter>
                    :
                        null
                    }
                </s.InnerPanel>
            </s.ExchangePanel>
        </s.MidSection>

        
        
    </s.Screen>

  );

};

export default Naming;